export default "__VITE_ASSET__DqgGFXAw__"